import * as z from 'zod';

// Types
import { MediaZod } from '@/types/MediaType';
import { TitleZod } from '@/types/TitleType';
import { CTAZod } from '@/types/CTAType';
import { WaveWrapperZod } from '@/types/WaveWrapperType';
import { ParagraphZod } from '@/components/atoms/Paragraph/ParagraphType';

const PressZod = z.object({
  __component: z.literal('block.press'),
  id: z.number(),
  title: TitleZod,
  cta: CTAZod.nullable(),
  waveWrapper: WaveWrapperZod.nullable(),
  items: z
    .array(
      z.object({
        id: z.number(),
        name: z.string(),
        paragraph: ParagraphZod,
        logo: MediaZod,
      }),
    )
    .default([]),
});

export { PressZod };
export type PressType = z.infer<typeof PressZod>;
